import { useSelector } from 'react-redux'

import { skipToken } from '@reduxjs/toolkit/query'

import { getAuthUserId } from '../../../../../data/auth/authSelectors'
import { RTKQueryHook, RTKQueryResultType } from '../../../../../data/baseApi'
import { useGetAppointmentByIdQuery } from '../appointmentsApi'

export const useAppointmentById: RTKQueryHook<typeof useGetAppointmentByIdQuery> = (args, opts) => {
  const userId = useSelector(getAuthUserId)
  return useGetAppointmentByIdQuery(
    userId && args?.appointmentId
      ? {
          providerId: userId,
          appointmentId: args.appointmentId,
          ...args,
        }
      : skipToken,
    opts,
  ) as RTKQueryResultType<typeof useGetAppointmentByIdQuery>
}
